export default {
    methods: {
        // 名字不能叫 dateFormat 会和 element 冲突
        dateFormat_0(fmt, date) {
            if ( null == date ) {
                return null;
            }

            var _date = null;

            if ( 'string' == typeof date ) { // 2020-04-16T06:17:51.000Z
                _date = new Date(date);
            } else if ( 'object' == typeof date ) {
                _date = date;
            } else {
                throw "type " + typeof date;
            }

            let ret;

            const opt = {
                "Y+": _date.getFullYear().toString(),        // 年
                "m+": (_date.getMonth() + 1).toString(),     // 月
                "d+": _date.getDate().toString(),            // 日
                "H+": _date.getHours().toString(),           // 时
                "M+": _date.getMinutes().toString(),         // 分
                "S+": _date.getSeconds().toString()          // 秒
                // 有其他格式化字符需求可以继续添加，必须转化成字符串
            };

            for (let k in opt) {
                ret = new RegExp("(" + k + ")").exec(fmt);

                if (ret) {
                    fmt = fmt.replace( // 
                        ret[1], //
                        (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")) // 
                    )
                };
            };

            return fmt;
        }
    }
}


// WEBPACK FOOTER //
// ./src/assets/mixins/DateFormatUtil.js